import { publicEventTimeZone } from '../events/eventPresentation.js';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useInitialPublicData } from '../../seo/PublicBootstrap.jsx';
import { fetchListingRelatedContent } from '../../services/api.js';

function eventDate(event) {
  const date = new Date(event.startsAt);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', { timeZone: event.allDay ? 'UTC' : publicEventTimeZone(event), month: 'short', day: 'numeric', year: 'numeric' });
}
export default function ListingRelatedContent({ listingId, tenantId }) {
  const initial = useInitialPublicData('listingRelated');
  const [state, setState] = useState({ key: `${tenantId}:${listingId}`, data: initial });
  const key = `${tenantId}:${listingId}`;
  useEffect(() => {
    if (initial) { setState({ key, data: initial }); return; }
    let active = true;
    fetchListingRelatedContent(listingId).then(data => { if (active) setState({ key, data }); }).catch(() => { if (active) setState({ key, data: null }); });
    return () => { active = false; };
  }, [initial, listingId, key]);
  const data = state.key === key ? state.data : initial;
  if (!data?.events?.length && !data?.articles?.length) return null;
  return <div className="mt-6 space-y-6">
    {data.events?.length ? <section className="rounded-xl border bg-white p-6" aria-labelledby="listing-events-heading">
      <h2 id="listing-events-heading" className="text-2xl font-bold">Upcoming events</h2>
      <ul className="mt-4 space-y-4">{data.events.map(event => <li key={event.id}><Link className="font-semibold text-[var(--primary)] hover:underline" to={event.publicPath}>{event.title}</Link><p className="text-sm text-slate-600"><time dateTime={event.startsAt}>{eventDate(event)}</time>{event.venueName ? ` · ${event.venueName}` : ''}</p></li>)}</ul>
    </section> : null}
    {data.articles?.length ? <section className="rounded-xl border bg-white p-6" aria-labelledby="listing-articles-heading">
      <h2 id="listing-articles-heading" className="text-2xl font-bold">Stories about this business</h2>
      <ul className="mt-4 space-y-4">{data.articles.map(article => <li key={article.id}><Link className="font-semibold text-[var(--primary)] hover:underline" to={article.publicPath}>{article.title}</Link>{article.excerpt ? <p className="mt-1 text-sm text-slate-600">{article.excerpt}</p> : null}</li>)}</ul>
    </section> : null}
  </div>;
}
